import { SelectOption } from "~tailwindui/types/SelectOption"

export const awsStreamingLocaleOptions: SelectOption[] = [
  { label: "Afrikaans", value: "af-ZA" },
  { label: "Arabic, Gulf", value: "ar-AE" },
  { label: "Arabic, Modern Standard", value: "ar-SA" },
  { label: "Basque", value: "eu-ES" },
  { label: "Catalan", value: "ca-ES" },
  { label: "Chinese, Cantonese", value: "zh-HK" },
  { label: "Chinese, Simplified", value: "zh-CN" },
  { label: "Chinese, Traditional", value: "zh-TW" },
  { label: "Croatian", value: "hr-HR" },
  { label: "Czech", value: "cs-CZ" },
  { label: "Danish", value: "da-DK" },
  { label: "Dutch", value: "nl-NL" },
  { label: "English (Australian)", value: "en-AU" },
  { label: "English (British)", value: "en-GB" },
  { label: "English (Indian)", value: "en-IN" },
  { label: "English (Irish)", value: "en-IE" },
  { label: "English (New Zealand)", value: "en-NZ" },
  { label: "English (Scottish)", value: "en-AB" },
  { label: "English (South African)", value: "en-ZA" },
  { label: "English (US)", value: "en-US" },
  { label: "English (Welsh)", value: "en-WL" },
  { label: "Farsi", value: "fa-IR" },
  { label: "Finnish", value: "fi-FI" },
  { label: "French (France)", value: "fr-FR" },
  { label: "French (Canada)", value: "fr-CA" },
  { label: "Galician", value: "gl-ES" },
  { label: "German (Germany)", value: "de-DE" },
  { label: "German (Switzerland)", value: "de-CH" },
  { label: "Greek", value: "el-GR" },
  { label: "Hebrew", value: "he-IL" },
  { label: "Hindi (India)", value: "hi-IN" },
  { label: "Indonesian", value: "id-ID" },
  { label: "Italian", value: "it-IT" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Korean", value: "ko-KR" },
  { label: "Latvian", value: "lv-LV" },
  { label: "Malay", value: "ms-MY" },
  { label: "Norwegian", value: "no-NO" },
  { label: "Polish", value: "pl-PL" },
  { label: "Portuguese (Portugal)", value: "pt-PT" },
  { label: "Portuguese (Brazil)", value: "pt-BR" },
  { label: "Romanian", value: "ro-RO" },
  { label: "Russian", value: "ru-RU" },
  { label: "Serbian", value: "sr-RS" },
  { label: "Slovak", value: "sk-SK" },
  { label: "Somali", value: "so-SO" },
  { label: "Spanish (Spain)", value: "es-ES" },
  { label: "Spanish (US)", value: "es-US" },
  { label: "Swedish", value: "sv-SE" },
  { label: "Tagalog / Filipino (Philippines)", value: "tl-PH" },
  { label: "Thai", value: "th-TH" },
  { label: "Ukrainian", value: "uk-UA" },
  { label: "Vietnamese", value: "vi-VN" },
  { label: "Zulu", value: "zu-ZA" },
]
